import useTokenExpirationTime from './useTokenExpirationTime'

export default useTokenExpirationTime
